import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Divider, Icon, Segment, Header } from 'semantic-ui-react';
import _ from 'lodash';

import MenuButtonList from 'PointOfSale/modules/mealTypes/container/MenuButtonList';
import FoodItemsList from 'PointOfSale/modules/mealTypes/container/FoodItemsList';
import ScrollContainer from 'PointOfSale/modules/common/container/ScrollContainer';
import TabMenus from 'PointOfSale/modules/common/component/TabMenus';
import 'PointOfSale/styles/components/mealsTypes.less';

const MealTypes = props => {
  const {
    currentSelectedMenu,
    tabMenus,
    tabClickHandler,
    searchHandler,
    searchText,
    selectedSiteDetails,
    onKeyboardFocus,
    keyboardInputRef,
    allItemsSelected,
    noItemsSelected,
    toggleSelectedItems,
    save,
  } = props;

  return (
    <React.Fragment>
      <div className="flex flex-col flex-no-wrap" style={{ overflow: 'auto' }}>
        {!_.isEmpty(selectedSiteDetails) && (
          <Segment>
            <Header as="h4" className="text-orange">
              Select a Meal Type
            </Header>
            <Grid>
              <MenuButtonList />
            </Grid>
          </Segment>
        )}
        {currentSelectedMenu && (
          <Segment className="flex-1 flex flex-col flex-no-wrap">
            <Header as="h4" className="text-orange">
              Select Items for Serving
            </Header>
            <TabMenus
              tabMenus={tabMenus}
              tabClickHandler={tabClickHandler}
              searchBox
              searchText={searchText}
              searchHandler={searchHandler}
              onKeyboardFocus={onKeyboardFocus}
              keyboardInputRef={keyboardInputRef}
            />
            <ScrollContainer className={'flex-8'} enableScrollButtons>
              <FoodItemsList />
            </ScrollContainer>
            <div className="flex-1">
              <Divider horizontal>
                <div>
                  <Icon
                    className="divider-icon"
                    disabled={allItemsSelected}
                    onClick={() => toggleSelectedItems(true)}
                    link
                    circular
                    size="large"
                    name="chevron circle down"
                  />
                  <Icon
                    className="divider-icon"
                    name="save"
                    size="large"
                    link
                    circular
                    onClick={save}
                  />
                  <Icon
                    className="divider-icon"
                    disabled={noItemsSelected}
                    flipped={'vertically'}
                    onClick={() => toggleSelectedItems(false)}
                    link
                    circular
                    size="large"
                    name="chevron circle down"
                  />
                </div>
              </Divider>
            </div>
            <ScrollContainer className={'flex-8'} enableScrollButtons>
              <FoodItemsList isSelectedFoodItemsBucket isFlat />
            </ScrollContainer>
          </Segment>
        )}
      </div>
    </React.Fragment>
  );
};

MealTypes.propTypes = {
  currentSelectedMenu: PropTypes.string,
  reset: PropTypes.func,
};
export default MealTypes;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/mealTypes/component/MealTypes.js